import NewContactsTable from './NewContactsTable';

export default NewContactsTable;
